export const CitationScanningSx = {
    outerContainer: {
      width: '100%',
      borderRadius: { xs: '8px', sm: '12px' },
      boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
      backgroundImage: 'url(/static/images/icons/local-seo/citation-scanning-bg.png)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      marginTop: { xs: '16px', sm: '24px' },
      marginBottom: { xs: '16px', sm: '24px' },
      minHeight: { xs: 'auto', sm: '565px' },
      paddingTop: { xs: '16px', sm: '32px' },
      paddingBottom: { xs: '16px', sm: '32px' },
      paddingX: { xs: '16px', sm: '32px' },
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: '16px', sm: '24px' },
      alignItems: 'center'
    },
    cardContainer: {
      width: '100%',
      maxWidth: { xs: '100%', sm: '828px' },
      backgroundColor: 'var(--color-white)',
      borderRadius: { xs: '8px', sm: '12px' },
      padding: { xs: '20px', sm: '24px' },
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)'
    },
    topCardTitle: {
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: { xs: '16px', sm: '18px' },
      lineHeight: { xs: '24px', sm: '28px' },
      color: 'var(--color-text-muted)',
      marginBottom: { xs: '8px', sm: '8px' },
      textAlign: 'center'
    },
    topCardDescription: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: { sm: '14px', xs: '14px' },
      lineHeight: { sm: '20px', xs: '22px' },
      color: 'var(--color-text-tertiary)',
      marginBottom: { xs: '20px', sm: '32px' },
      textAlign: 'center'
    },
    scanningStatus: {
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: { sm: '14px' },
      lineHeight: { sm: '20px' },
      color: 'var(--color-primary)',
      marginBottom: { sm: '8px' }
    },
    progressBar: {
      height: { xs: '6px', sm: '8px' },
      borderRadius: '4px',
      backgroundColor: 'var(--color-success-bg-lightest)',
      '& .MuiLinearProgress-bar': {
        backgroundColor: 'var(--color-secondary)',
        borderRadius: '4px'
      }
    },
    bottomCardTitle: {
      textAlign: 'center',
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: { sm: '18px' },
      lineHeight: { sm: '28px' },
      color: 'var(--color-text-muted)',
      marginBottom: { sm: '8px' }
    },
    bottomCardIntro: {
      textAlign: 'center',
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: { sm: '14px', xs: '14px' },
      lineHeight: { sm: '20px', xs: '22px' },
      color: 'var(--color-text-tertiary)',
      marginBottom: { sm: '32px', xs: '32px' },
      maxWidth: { sm: '90%', xs: '100%' },
      marginLeft: { xs: 'auto', sm: 'auto' },
      marginRight: { xs: 'auto', sm: 'auto' }
    },
    featureList: {
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: '12px', sm: '12px' }
    },
    featureItem: {
      display: 'flex',
      alignItems: 'center',
      gap: { xs: '12px', sm: '12px' }
    },
    checkmarkCircle: {
      width: { xs: '24px', sm: '36px' },
      height: { xs: '24px', sm: '36px' },
      borderRadius: '50%',
      backgroundColor: 'var(--color-success-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    checkmarkIcon: {
      color: '#10B981',
      fontSize: { xs: '16px', sm: '20px' }
    },
    featureText: {
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: { xs: '14px', sm: '14px' },
      lineHeight: { xs: '20px', sm: '20px' },
      color: 'var(--color-text-muted)'
    }
  };